import { Selection, DefaultButton, IPanelStyles, Link, List, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, EventGroup, SelectionMode } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { IFascicolo } from '../../../../shared/interfaces';
import { RootState } from '../../../../store';
import { error } from 'console';
import ErrorUtilities from '../../../../shared/Utilities/errorUtilities';
import RippleLoader from '../../../Loader/RippleLoader/RippleLoader';
import FascicoliTree from '../../../Fascicoli/FascicoliTree';
import protocolliFascicoliService from '../../../../services/protocolliFascicoli.service';
import { TreeSelectionKeys, TreeSelectionParams } from 'primereact/tree';
import Fascicolo from '../DetailsViewer/FascicoliDiProtocollo/FascicoliDiProtocollo';

const queryString = require('query-string');

export interface AddFascicoliDiProtocolloPanelProps {
    loading?: boolean
    extraCssClass?: string
    addToFascicoloPanelIsOpen: boolean
    selectedFascicoloNode?: IFascicolo
    onAddToFascicoloSubmit: () => void
    onAddToFascicoloDismiss: () => void

}

type Props = AddFascicoliDiProtocolloPanelProps & RouteComponentProps

const AddFascicoliDiProtocolloPanel: React.FunctionComponent<Props> = (props) => {

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol
    const currentProtocol = useSelector(selectCurrentProtocol);


    let [panelIsOpen, { setTrue: openAddToFascicoloPanel, setFalse: dismissAddToFascicoloPanel }] = useBoolean(props.addToFascicoloPanelIsOpen);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info)
    let [messageBarText, setMessageBarText] = useState<string>('')

    let [addToFascicoloBtnEnable, { setTrue: enableAddToFascicoloBtn, setFalse: disableAddToFascicoloBtn }] = useBoolean(false);
    let [addToFascicoloBtnText, setAddToFascicoloBtnText] = useState<string>('Aggiungi al fascicolo')

    let [actionsLoader, { setTrue: showActionsLoader, setFalse: hideActionsLoader }] = useBoolean(false);


    const [fascicoloSelection, setFascicoloSelection] = useState<IFascicolo>(props.selectedFascicoloNode!);

    useEffect(() => {

        if (fascicoloSelection && !fascicoloSelection.dataChiusura) {
            enableAddToFascicoloBtn();
            setAddToFascicoloBtnText('Aggiungi fascicolo');
        }
        else {
            disableAddToFascicoloBtn();
            setAddToFascicoloBtnText('Aggiungi fascicolo');
        }

    }, [fascicoloSelection]);


    const addToFascicoloPanelSubmit = () => {
        showActionsLoader();
        protocolliFascicoliService.addProtocolToFascicolo(currentAoo!.id, currentUor!.id!, currentProtocol!.id!, fascicoloSelection.id)
            .then(result => {
                props.onAddToFascicoloSubmit();
            },
                error => {

                    let myArgumentException = ErrorUtilities.GetMyArgumentExceptionFromError(error);

                    if (myArgumentException && myArgumentException.showMessageInClientApp) {
                        setMessageBarType(MessageBarType.warning);
                        setMessageBarText(myArgumentException.message);
                    }
                    else {
                        setMessageBarType(MessageBarType.error);
                        setMessageBarText("Errore nell'associazione al fascicolo");

                    }
                    showMessageBar();
                }
            )
            .finally(() => {
                hideActionsLoader();
            });
    }

    const addToFascicoloPanelDismiss = () => {
        props.onAddToFascicoloDismiss();
    }

    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text={addToFascicoloBtnText}
                    onClick={addToFascicoloPanelSubmit}
                    disabled={!addToFascicoloBtnEnable}

                />
                <DefaultButton
                    onClick={addToFascicoloPanelDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    const onSelectFascicoloHandler = (selected: IFascicolo) => {
        let itemKey: number;
        if (selected) {
            itemKey = selected.id;
        }
        setFascicoloSelection(selected)

    }

    return (
        <React.Fragment>
            <div className={`loader opacity ${actionsLoader ? "active" : ""}`} style={{ zIndex: 999999999999 }} >
                <RippleLoader text='Operazione in corso' />
            </div>

            <Panel
                key='addToFascicoloPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'800px'}
                headerText="Fascicoli"
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={addToFascicoloPanelDismiss}
                onRenderFooterContent={onRenderFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}


            >
                {
                    messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <FascicoliTree
                    onSelectFascicoloHandler={(selected) => onSelectFascicoloHandler(selected!)}
                />



            </Panel>
        </React.Fragment>
    );
}


export default AddFascicoliDiProtocolloPanel;